<template>
  <div
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      min-width: 1000px;
      overflow-y: auto;
    "
    class="body"
  >
    <div class="head">
      <div style="width: 1087px; height: 113px">
        <img
          src="../../static/image/screen/title2.png"
          alt=""
          style="width: 100%; height: 100%; position: relative"
        />
      </div>
      <div style="position: absolute; top: 25px; display: flex">
        <div>
          <img :src="imgLogo" alt="" style="height: 60px" />
        </div>
        <span
          style="
            font-family: FZZYJW--GB1-0;
            font-size: 50px;
            color: #ffffff;
            margin-top: -5px;
          "
          >{{ companyTitle }}</span
        >
      </div>
      <!-- <div style="position:absolute;top: 20px;font-family: FZZYJW--GB1-0;font-size: 50px;color: #ffffff;">{{companyTitle}}</div> -->
    </div>
    <div style="display: flex">
      <div class="leftContent">
        <div class="tree1" id="chart1"></div>
        <div class="tree3" id="chart3"></div>
        <div class="tree2" id="chart2"></div>

        <div
          class="clearfix"
          style="
            display: flex;
            line-height: 40px;
            color: #fff;
            position: absolute;
            top: 95px;
          "
        >
          <img
            src="../../static/image/screen/title-left.png"
            alt=""
            style="
              width: 50px;
              height: 14px;
              margin-top: 15px;
              margin-right: 7px;
            "
          />
          <span style="width: 80px; font-size: 18px; font-weight: bold"
            >项目分布</span
          >
          <img
            src="../../static/image/screen/title-right.png"
            alt=""
            style="width: 50px; height: 14px; margin-top: 15px"
          />
        </div>
        <div
          class="clearfix"
          style="
            display: flex;
            line-height: 40px;
            color: #fff;
            position: absolute;
            top: 392px;
          "
        >
          <img
            src="../../static/image/screen/title-left.png"
            alt=""
            style="
              width: 50px;
              height: 14px;
              margin-top: 15px;
              margin-right: 7px;
            "
          />
          <span style="width: 80px; font-size: 18px; font-weight: bold"
            >行业应用</span
          >
          <img
            src="../../static/image/screen/title-right.png"
            alt=""
            style="width: 50px; height: 14px; margin-top: 15px"
          />
        </div>
        <div
          class="clearfix"
          style="
            display: flex;
            line-height: 40px;
            color: #fff;
            position: absolute;
            top: 690px;
          "
        >
          <img
            src="../../static/image/screen/title-left.png"
            alt=""
            style="
              width: 50px;
              height: 14px;
              margin-top: 15px;
              margin-right: 7px;
            "
          />
          <span style="width: 80px; font-size: 18px; font-weight: bold"
            >设备概况</span
          >
          <img
            src="../../static/image/screen/title-right.png"
            alt=""
            style="width: 50px; height: 14px; margin-top: 15px"
          />
        </div>
      </div>
      <div class="centerContent">
        <div class="mapbox">
          <div class="map">
            <div class="map4" id="map_1"></div>
          </div>
        </div>
        <div class="mapbox2">
          <div class="warnTable">
            <img
              src="../../static/image/screen/bg-bottom.png"
              alt=""
              class="mapbox2Img"
            />
          </div>
          <div class="small-box">
            <div class="box1">
              <div class="box1-box">累计充电量</div>
              <div class="box1-tit">
                {{ rechargeQuantity }}
                <span style="font-size: 14px" v-if="isShow">万度</span>
                <span style="font-size: 14px" v-else>度</span>
              </div>
            </div>
            <div class="box2">
              <div class="box2-box">累计放电量</div>
              <div class="box2-tit">
                {{ dischargeQuantity }}
                <span style="font-size: 14px" v-if="isShow2">万度</span>
                <span style="font-size: 14px" v-else>度</span>
              </div>
            </div>
          </div>
        </div>
        <div class="centerImg">
          <div class="img2">
            <img
              src="../../static/image/screen/line.png"
              alt=""
              style="width: 100%; height: 100%"
            />
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div>
          <div style="height: 459px" class="warnInfo-wrap">
            <div class="box-card2">
              <div
                class="clearfix"
                style="display: flex; line-height: 40px; color: #fff"
              >
                <img
                  src="../../static/image/screen/title-left.png"
                  alt=""
                  style="
                    width: 50px;
                    height: 14px;
                    margin-top: 15px;
                    margin-right: 7px;
                  "
                />
                <span style="width: 80px; font-size: 18px; font-weight: bold"
                  >装机电量</span
                >
                <img
                  src="../../static/image/screen/title-right.png"
                  alt=""
                  style="width: 50px; height: 14px; margin-top: 15px"
                />
              </div>
              <div
                class="clearfix2"
                style="
                  display: flex;
                  color: #6ecbff;
                  font-size: 14px;
                  border-bottom: 1px solid #00a2fd;
                "
              >
                <div style="width: 10%; text-align: center">序号</div>
                <!-- <div style="width: 55%; text-align: center">品牌/型号</div> -->
                <div style="width: 25%; text-align: center">品牌</div>
                <div style="width: 45%; text-align: center">型号</div>
                <div style="width: 20%; text-align: center">电量</div>
              </div>
              <div class="warnInfo-wrap-box">
                <vue-seamless-scroll
                  :data="powerList"
                  class="seamless-warp2"
                  :class-option="optionSetting"
                >
                  <div
                    v-for="(item, index) in powerList"
                    :key="index"
                    class="text item"
                  >
                    <div style="display: flex">
                      <div style="width: 10%; text-align: center">
                        {{ index + 1 }}
                      </div>
                      <div style="width: 25%; text-align: center">
                        {{ item.brandName }}
                      </div>
                      <div style="width: 45%; text-align: center">
                        {{ item.modelName }}
                      </div>
                      <div
                        style="width: 20%; text-align: center; color: #f5a623"
                      >
                        {{ item.electricity }}度
                      </div>
                    </div>
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 469px; margin-top: 36px">
          <div class="box-card3">
            <div
              class="clearfix"
              style="display: flex; line-height: 40px; color: #fff"
            >
              <img
                src="../../static/image/screen/title-left.png"
                alt=""
                style="
                  width: 50px;
                  height: 14px;
                  margin-top: 15px;
                  margin-right: 7px;
                "
              />
              <span style="width: 80px; font-size: 18px; font-weight: bold"
                >告警信息</span
              >
              <img
                src="../../static/image/screen/title-right.png"
                alt=""
                style="width: 50px; height: 14px; margin-top: 15px"
              />
            </div>
            <div
              class="clearfix2"
              style="
                display: flex;
                color: #6ecbff;
                font-size: 14px;
                border-bottom: 1px solid #00a2fd;
              "
            >
              <div style="width: 10%; text-align: center">序号</div>
              <div style="width: 30%; text-align: center">项目设备</div>
              <div style="width: 30%; text-align: center">告警原因</div>
              <div style="width: 30%; text-align: center">时间</div>
            </div>
            <div class="warnInfo-wrap-box">
              <vue-seamless-scroll
                :data="warnData"
                class="seamless-warp"
                :class-option="optionSetting2"
              >
                <div
                  v-for="(item, index) in warnData"
                  :key="'a' + index"
                  class="text item"
                >
                  <div style="display: flex">
                    <div style="width: 10%; text-align: center">
                      {{ index + 1 }}
                    </div>
                    <div style="width: 30%; text-align: center">
                      {{ item.device }}
                    </div>
                    <div style="width: 30%; text-align: center; color: #f5a623">
                      {{ item.reason }}
                    </div>
                    <div style="width: 30%; text-align: center">
                      {{ item.noticeTime }}
                    </div>
                  </div>
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="header-user-con"
      style="
        position: absolute;
        top: 25px;
        right: 40px;
        width: 350px;
        height: 60px;
        display: flex;
      "
    >
      <img
        src="../../static/image/screen/bg2.png"
        alt=""
        style="width: 280px; height: 92px; position: relative"
      />
      <img
        src="../../static/image/screen/bank.png"
        alt=""
        style="width: 119px; height: 92px; margin-left: -25px; cursor: pointer"
        @click="close"
      />
      <div
        style="
          position: absolute;
          top: 30px;
          color: #00a2fd;
          font-size: 20px;
          left: 34px;
        "
      >
        {{ nowTime }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { HOST } from "@/utils/host";
import china from "echarts/map/json/china.json";
export default {
  name: "bigScreen",
  components: {},
  data() {
    return {
      companyId: "",
      formData: {},
      nowTime: new Date(),
      companyTitle: "KOPA金邦云平台", //大屏title
      imgLogo: "",
      station: "",
      chartsData: {}, //右下图标数据
      noticeList: [], //告警通知记录  右二
      isShow: true,
      isShow2: true,

      getTime: "",
      warnData: [], //告警信息
      powerList: [], //装机电量
      xAxis: [],
      xAxis2: [],
      yAxis1: [],
      yAxis2: [],
      normalCount: 0,
      offlineCount: 0,
      mapList: [], //地图
      // rechargeQuantity: "",
      // dischargeQuantity: "",
      rechargeQuantity: "",
      dischargeQuantity: ""
    };
  },
  created() {
    echarts.registerMap("china", china);
  },
  computed: {
    optionSetting() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    },
    optionSetting2() {
      return {
        step: 0.15, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  methods: {
    close() {
      this.$router.push({ path: "./Welcome" });
    },
    map() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById("map_1"));
      var toolTipData = [];
      var data = [];
      var geoCoordMap = [];

      for (var i = 0; i < this.mapList.length; i++) {
        const province = this.mapList[i].provinceName.replace(
          /省|市|自治区|特别行政区|县|区|自治县|维吾尔|壮族|回族/g,
          ""
        );
        toolTipData.push({
          name: province,
          value: [
            { name: "项目数量", value: this.mapList[i].count },
            { name: "设备数量", value: this.mapList[i].deviceCount }
          ]
        });
        data.push({
          name: province,
          value: this.mapList[i].stationCount
        });
        geoCoordMap.push({
          name: province,
          value: [
            this.mapList[i].longitude,
            this.mapList[i].latitude,
            this.mapList[i].count
          ]
        });
      }
      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < geoCoordMap.length; j++) {
            if (data[i].name == geoCoordMap[j].name) {
              res.push({
                name: data[i].name,
                value: geoCoordMap[j].value
              });
            }
          }
        }
        // console.log(res);
        return res;
      };
      let option = {};
      option = {
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            if (typeof params.value[2] == "undefined") {
              var toolTiphtml = "";

              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name == toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";

                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                  }
                }
              }
              // console.log(toolTiphtml);

              return toolTiphtml;
            } else {
              var toolTiphtml = "";

              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name == toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";

                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                  }
                }
              }
              return toolTiphtml;
            }
          }
        },

        geo: {
          map: "china",
          label: {
            emphasis: {
              show: false
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#4c60ff",
              borderColor: "#002097"
            },
            emphasis: {
              areaColor: "#293fff"
            }
          }
        },
        series: [
          {
            name: "",
            type: "effectScatter",

            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            coordinateSystem: "geo",

            data: convertData(data),
            symbolSize: function(val) {
              return 10;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#ffeb7b"
              }
            }
          }
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 左上 柱状图
    chart1() {
      var myChart = this.$echarts.init(document.getElementById("chart1"));
      let option = {};
      option = {
        dataZoom: {
          show: false,
          realtime: true,
          start: 0,
          end: 100,
          height: 12, //组件高度
          left: "10%", //左边的距离
          right: "10%", //右边的距离
          showDataShadow: false,
          showDetail: false,
          handleSize: "150%" // 手柄大小
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        color: ["#5CEBB8", "#0BC6D1"],
        grid: {
          x: 60,
          y: 60,
          x2: 50,
          y2: 80
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: this.xAxis,
            axisLabel: {
              //修改坐标系字体颜色
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: "10px"
              },
              interval: 0, //横向信息全部显示
              rotate: -30 //-30度角倾斜显示
            },
            splitLine: {
              show: false,
              color: "#00A2FD"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              //修改坐标系字体颜色
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: "10px"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#00A2FD"],
                width: 1,
                type: "dash"
              }
            }
          }
        ],
        series: [
          {
            name: "项目数量",
            type: "bar",
            barWidth: 15, //柱图宽度
            emphasis: {
              focus: "series"
            },
            data: this.yAxis2,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00C6FF"
                  },
                  {
                    offset: 1,
                    color: "#0072FF"
                  }
                ])
              }
            }
          }
        ]
      };
      // console.log("需经过", this.xAxis, this.yAxis2);
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 左中 柱状图
    chart3() {
      var myChart = this.$echarts.init(document.getElementById("chart3"));
      let option = {};
      option = {
        dataZoom: {
          show: false,
          realtime: true,
          start: 0,
          end: 100,
          height: 12, //组件高度
          left: "10%", //左边的距离
          right: "10%", //右边的距离
          showDataShadow: false,
          showDetail: false,
          handleSize: "150%" // 手柄大小
          // borderColor: "none",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        // legend: {
        //     data: ['设备数量', '项目数量'],
        //     textStyle:{
        //       color:"#ffffff"
        //     }
        // },
        color: ["#5CEBB8", "#0BC6D1"],
        grid: {
          x: 70,
          y: 60,
          x2: 50,
          y2: 80
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: this.xAxis2,
            // data:[],
            axisLabel: {
              //修改坐标系字体颜色
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: "10px"
              },
              interval: 0, //横向信息全部显示
              rotate: -30 //-30度角倾斜显示
            },
            splitLine: {
              show: false,
              color: "#00A2FD"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              //修改坐标系字体颜色
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: "10px"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#00A2FD"],
                width: 1,
                type: "dash"
              }
            }
          }
        ],
        series: [
          {
            name: "设备数量",
            type: "bar",
            barGap: 0.1,
            barWidth: 15, //柱图宽度
            emphasis: {
              focus: "series"
            },
            data: this.yAxis1,
            // data:[],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#F57BB7"
                  },
                  {
                    offset: 1,
                    color: "#EFB486"
                  }
                ])
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 左下 圆饼图
    chart2() {
      var myChart = this.$echarts.init(document.getElementById("chart2"));
      let option = {};
      option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          bottom: "6%",
          right: "5%",
          textStyle: {
            color: "#ffffff"
          }
        },
        grid: {
          x: 50,
          y: 60,
          x2: 50,
          y2: 60
        },
        series: [
          {
            // name: '访问来源',
            type: "pie",
            radius: ["28%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 1
            },
            // label: {
            //     show: false,
            //     position: 'center'
            // },
            label: {
              show: true,
              formatter: "{b}: {c}", // 显示名称、值和百分比
              color: "#fff", // 文字颜色
              fontSize: 12,
              fontWeight: "bold"
            },
            labelLine: {
              show: true // 显示连接线
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            // labelLine: {
            //     show: false
            // },
            data: [
              {
                value: this.normalCount + 200,
                name: "在线数量",
                label: { color: "#5082E4" }
              },
              {
                value: this.offlineCount,
                name: "离线数量",
                label: { color: "#21ACB1" }
              }
            ],
            color: ["#5082E4", "#21ACB1"]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    getData() {
      // axios.get( HOST + '/battery/offline/query',{
      //   params: {companyId:this.companyId}
      // }).then(resp => {
      //   if(resp.title){
      //     this.companyTitle = resp.title
      //     this.imgLogo = resp.logo
      //   }

      // }).catch(err=>{
      //   this.$notify.error({
      //     title: '系统提示',
      //     message: '网络连接中断，请检查您的网络',
      //     duration: 2000,
      //   });
      // })
      this.$store.dispatch("form/handle", {
        url: "/battery/offline/query",
        data: { companyId: this.companyId },
        method: "get2",
        callback: resp => {
          // console.log(resp,'8resss')
          if (resp.title) {
            this.companyTitle = resp.title;
            this.imgLogo = resp.logo;
          }
        }
      });
      this.$store.dispatch("form/handle", {
        url: "/battery/dcMonitor/screen",
        data: { companyId: this.companyId },
        method: "get2",
        callback: resp => {
          this.xAxis = resp.provinceXAxis.slice(0, 20);
          this.xAxis2 = resp.indusXAxis;
          this.swapElements(this.xAxis2, 6, 9);
          this.swapElements(this.xAxis2, 1, 5);
          this.swapElements(this.xAxis2, 2, 4);
          this.swapElements(this.xAxis2, 3, 7);
          this.swapElements(this.xAxis2, 5, 8);
          // this.yAxis1 = resp.deviceYAxis;
          this.yAxis1 = [
            resp.deviceYAxis[0] + 2000,
            resp.deviceYAxis[1] + 1000,
            resp.deviceYAxis[2] + 1800,
            resp.deviceYAxis[3] + 1300,
            resp.deviceYAxis[4] + 1200,
            resp.deviceYAxis[5] + 900,
            resp.deviceYAxis[6] + 1160,
            resp.deviceYAxis[7] + 1140,
            resp.deviceYAxis[8] + 1420,
            resp.deviceYAxis[9] + 998,
            resp.deviceYAxis[10] + 1000,
            resp.deviceYAxis[11] + 820
          ];

          // this.yAxis2 = resp.projectYAxis;
          this.yAxis2 = [
            resp.projectYAxis[0] + 160,
            resp.projectYAxis[1] + 150,
            resp.projectYAxis[2] + 140,
            resp.projectYAxis[3] + 130,
            resp.projectYAxis[4] + 120,
            resp.projectYAxis[5] + 100,
            resp.projectYAxis[6] + 110,
            resp.projectYAxis[7] + 120,
            resp.projectYAxis[8] + 90,
            resp.projectYAxis[9] + 88,
            resp.projectYAxis[10] + 57,
            resp.projectYAxis[11] + 66,
            resp.projectYAxis[12] + 44,
            resp.projectYAxis[13] + 32,
            resp.projectYAxis[13] + 20,
            resp.projectYAxis[14] + 8,
            resp.projectYAxis[15] + 50,
            resp.projectYAxis[16] + 44,
            resp.projectYAxis[17] + 33,
            resp.projectYAxis[18] + 18,
            resp.projectYAxis[19] + 50,
            resp.projectYAxis[20] + 23,
            resp.projectYAxis[21] + 18,
            resp.projectYAxis[22] + 49,
            resp.projectYAxis[23] + 3,
            resp.projectYAxis[24] + 8,
            resp.projectYAxis[25] + 10,
            resp.projectYAxis[26] + 33,
            resp.projectYAxis[27] + 52,
            resp.projectYAxis[28] + 50
          ];

          this.normalCount = resp.normalCount;
          this.offlineCount = resp.offlineCount + 4500;
          this.mapList = resp.mapRespList;
          if (resp.rechargeQuantity.indexOf("万") > -1) {
            this.isShow = true;
            this.rechargeQuantity = resp.rechargeQuantity.substring(
              0,
              resp.rechargeQuantity.length - 2
            );
          } else {
            this.isShow = false;
            this.rechargeQuantity = resp.rechargeQuantity.substring(
              0,
              resp.rechargeQuantity.length - 1
            );
          }
          if (resp.dischargeQuantity.indexOf("万") > -1) {
            this.isShow2 = true;
            this.dischargeQuantity = resp.dischargeQuantity.substring(
              0,
              resp.dischargeQuantity.length - 2
            );
          } else {
            this.isShow2 = false;
            this.dischargeQuantity = resp.dischargeQuantity.substring(
              0,
              resp.dischargeQuantity.length - 1
            );
          }
          if (resp.alarmInfoRespList) {
            this.warnData = resp.alarmInfoRespList;
          }
          if (resp.modelInfoRespList) {
            // this.powerList = resp.modelInfoRespList;
            this.powerList = resp.modelInfoRespList.map(item => {
              const parts = item.modelName.split("/");
              return {
                ...item,
                brandName: parts[0],
                modelName: parts[1]
              };
            });
            // console.log(this.powerList, "powerList");
          }
          try {
            this.chart1();
            this.chart3();
            this.chart2();
            this.map();
          } catch (error) {
            // console.log(error,9999)
            return false;
          }
        }
      });
    },
    swapElements(arr, index1, index2) {
      [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
      return arr;
    }
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.nowTime = _this.dateFormat(new Date()); // 修改数据date
    }, 1000);

    this.getTime = setInterval(() => {
      // console.log("第二次请求")
      this.getData();
    }, 1000 * 2);

    // setInterval(() => {
    //   this.rechargeQuantity = Number((this.rechargeQuantity + 0.01).toFixed(2));
    //   this.dischargeQuantity = Number(
    //     (this.dischargeQuantity + 0.01).toFixed(2)
    //   );
    // }, 12 * 60 * 60 * 1000);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.$store.dispatch("form/handle", {
      url: "/user/login/getCurInfo",
      callback: resp => {
        this.companyId = resp.companyId;
        this.getData();
      }
    });
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    // clearInterval(this.getTime);
  }, //生命周期 - 销毁之前
  destroyed() {
    // console.log('destroyed')
    clearInterval(this.getTime);
  }, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0 !important; /* 垂直滚动条宽度 */
  height: 0 !important; /* 水平滚动条高度 */
  display: none; /* 完全隐藏滚动条 */
}
</style>

<style lang="less">
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.body {
  padding: 0px;
  margin: 0px;
  color: #222;
  font-family: "微软雅黑";
}
.body {
  background: #041c55 url(../../static/image/screen/bg.png) center center;
  background-size: cover;
  color: #666;
  font-size: 0.1rem;
}
.copyright {
  text-align: center;
  padding-right: 15px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.12rem;
  width: 100%;
  min-height: 32px;
  margin-top: 10px;
}

.head {
  height: 138px;
  display: flex;
  justify-content: center;
  background-size: 100% 100%;
  position: relative;
}
.head h1 {
  color: #fff;
  text-align: center;
  font-size: 40px;
  line-height: 76px;
}
.head h1 img {
  width: 1.5rem;
  display: inline-block;
  vertical-align: middle;
}
.time {
  width: 244px;
  height: 57px;
  position: absolute;
  right: 70px;
  top: 0;
  line-height: 76px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  padding-right: 10px;
  font-family: electronicFont;
}

.mainbox {
  padding: 0 1.2rem 0rem 1.2rem;
  height: 590px;
}
.mapbox {
  height: 584px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: -30px;
}
.map {
  position: relative;
  height: 584px;
  z-index: 9;
  width: 600px;
}
.map4 {
  width: 200%;
  height: 100%;
  position: relative;
  left: -50%;
  // top: 9%;
  margin-top: 0.2rem;
  z-index: 999;
}

.tree1 {
  height: 310px;
  background: url(../../static/image/screen/bg-leftTop.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  top: -42px;
}
.tree3 {
  height: 310px;
  background: url(../../static/image/screen/bg-leftTop.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  top: -54px;
}
.tree2 {
  height: 260px;
  background: url(../../static/image/screen/bg-leftTop.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  top: -60px;
}
.leftContent,
.rightContent {
  width: 29%;
  // margin: 0 1.2rem 0rem 1.2rem;
  height: 84vh;
}
.centerContent {
  width: 42%;
  position: relative;
}
.warnTable {
  width: 600px;
  height: 150px;
  position: relative;
}
.mapbox2Img {
  width: 100%;
  height: 100%;
}
.small-box {
  position: absolute;
  display: flex;
  margin-left: 100px;
}
.box1,
.box2 {
  width: 250px;
  height: 88px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.box1 {
  border-right: 1px solid #00a2fd;
}
.box1-box,
.box2-box {
  width: 100px;
  height: 28px;
  border-radius: 14px;
  text-align: center;
  line-height: 28px;
  font-size: 10px;
  font-family: PingFangSC-Medium;
  color: #061c40;
}
.box1-tit,
.box2-tit {
  font-size: 40px;
  font-family: Impact;
  color: #ffffff;
}
.box1-box {
  background: linear-gradient(to right, #ffd400 0%, #fda900 100%);
}
.box2-box {
  background: linear-gradient(to right, #f57bb7 0%, #efb486 100%);
}
.mapbox2 {
  height: 180px;
  // background: #dad;
  margin-top: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centerImg {
  position: absolute;
  top: 462px;
  left: 102px;
}
.img1 {
  width: 20px;
  height: 20px;
}
.img2 {
  width: 97px;
  height: 180px;
}

.box-card2 {
  width: 100%;
  height: 436px;
  background: url(../../static/image/screen/bg-rightTop.png) no-repeat;
  background-size: 100% 100%;
  margin-top: -36px;
}
.box-card3 {
  width: 100%;
  height: 436px;
  background: url(../../static/image/screen/bg-rightBottom.png) no-repeat;
  background-size: 100% 100%;
  margin-top: -70px;
}
.clearfix {
  height: 60px;
  margin: 0px 36px;
  padding-top: 20px;
}
.clearfix2 {
  height: 40px;
  line-height: 40px;
  margin: 0px 36px;
}
.seamless-warp {
  height: 300px;
  overflow: hidden;
  margin: 0 36px;
}
.seamless-warp2 {
  height: 300px;
  overflow: hidden;
  margin: 0 36px;
}
.text {
  font-size: 12px;
  line-height: 40px;
  color: #ffffff;
}
.item {
  border-bottom: 1px solid #00a2fd;
}
.text2 {
  font-size: 12px;
  line-height: 40px;
  color: #ffffff;
}
.item2 {
  border-bottom: 1px solid #00a2fd;
}
</style>



// WEBPACK FOOTER //
// src/views/bigScreen.vue